export default "__VITE_ASSET__DrjP9zj8__"